'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  time: null,
  busy: false,
  reason: null,
  relatedEventStartTime: null,
  ownerFirstName: null,
  ownerLastName: null,
  ownerEmail: null
}, 'TroubleshotStartTime');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/models/TroubleshotStartTime.js
// module id = 388
// module chunks = 0